import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dialog-portfolio-warning',
  templateUrl: './dialog-portfolio-warning.component.html',
  styleUrls: ['./dialog-portfolio-warning.component.scss'],
  standalone: false
})
export class DialogPortfolioWarningComponent {
  @Input() undoLoading: boolean;
  @Output() closeWarning: EventEmitter<void> = new EventEmitter<void>();
  @Output() undoChange: EventEmitter<void> = new EventEmitter<void>();

  onUndo() {
    this.undoChange.emit();
  }

  onClose() {
    if (this.undoLoading) {
      return;
    }
    this.closeWarning.emit();
  }
}
